/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_AssigneeInputs */

const cs_col_assignee = /** @type {(inputs: Col_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Řešitel`)
};

const en_col_assignee = /** @type {(inputs: Col_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignee`)
};

/**
* | output |
* | --- |
* | "Assignee" |
*
* @param {Col_AssigneeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_assignee = /** @type {((inputs?: Col_AssigneeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_AssigneeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_assignee(inputs)
	return cs_col_assignee(inputs)
});